// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import type { ChatSession } from '../../types';

interface ChatSessionSidebarProps {
  isOpen: boolean;
  sessions: ChatSession[];
  loading: boolean;
  activeSessionId: string | undefined;
  onClose: () => void;
  onNewChat: () => void;
  onSelectSession: (_sessionId: string) => void;
}

function ChatSessionSidebar({
  isOpen,
  sessions,
  loading,
  activeSessionId,
  onClose,
  onNewChat,
  onSelectSession,
}: ChatSessionSidebarProps) {
  return (
    <>
      <div className={`session-sidebar ${isOpen ? 'session-sidebar-open' : ''}`}>
        <div className="session-sidebar-header">
          <h4 className="session-sidebar-title">Chat History</h4>
        </div>
        <button className="session-new-chat-btn" onClick={onNewChat}>
          + New Chat
        </button>
        <div className="session-list">
          {loading ? (
            <div className="session-loading">Loading sessions...</div>
          ) : sessions.length === 0 ? (
            <div className="session-empty">No previous sessions</div>
          ) : (
            sessions.map(session => (
              <button
                key={session.session_id}
                className={`session-item ${session.session_id === activeSessionId ? 'session-item-active' : ''}`}
                onClick={() => onSelectSession(session.session_id)}
              >
                <span className="session-item-icon">💬</span>
                <div className="session-item-content">
                  <span className="session-item-id">{session.session_id.slice(0, 8)}...</span>
                  {session.created_at && (
                    <span className="session-item-date">
                      {new Date(session.created_at).toLocaleDateString()}
                    </span>
                  )}
                </div>
              </button>
            ))
          )}
        </div>
      </div>

      {isOpen && <div className="session-sidebar-overlay" onClick={onClose} />}
    </>
  );
}

export default ChatSessionSidebar;
